import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { calculateScenario } from './calculations';
import { fmt, fmtPct, fmtFiling } from './formatters';
import { computePositiveRecommendations } from './positiveRecommendations';

// HealthCues full logo SVG (mark + wordmark)
const LOGO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="157" height="42" viewBox="0 0 157 42"><g><g><path fill="#0F1C29" d="M62.591,15.588v11.688H60.42v-5.008h-6.044v5.008h-2.171V15.588h2.171v4.826h6.044v-4.826H62.591z"/><path fill="#0F1C29" d="M74.714,23.487h-6.997c0.25,1.302,1.336,2.137,2.889,2.137c1.002,0,1.786-0.317,2.42-0.968l1.12,1.285c-0.802,0.953-2.054,1.453-3.591,1.453c-2.988,0-4.926-1.92-4.926-4.575c0-2.654,1.954-4.558,4.608-4.558c2.605,0,4.509,1.82,4.509,4.608C74.748,23.036,74.731,23.287,74.714,23.487z M67.701,22.101h5.06c-0.167-1.286-1.152-2.171-2.522-2.171C68.887,19.93,67.902,20.798,67.701,22.101z"/><path fill="#0F1C29" d="M84.801,22.051v5.225H82.83v-1.084c-0.501,0.768-1.47,1.201-2.805,1.201c-2.039,0-3.324-1.119-3.324-2.671c0-1.486,1.002-2.655,3.707-2.655h2.305v-0.133c0-1.219-0.734-1.937-2.221-1.937c-1.002,0-2.037,0.334-2.705,0.885l-0.818-1.52c0.951-0.734,2.337-1.101,3.774-1.101C83.314,18.261,84.801,19.479,84.801,22.051z M82.713,24.489v-1.035h-2.154c-1.419,0-1.803,0.534-1.803,1.185c0,0.751,0.634,1.235,1.703,1.235C81.478,25.874,82.362,25.407,82.713,24.489z"/><path fill="#0F1C29" d="M88.307,14.888h2.088v12.389h-2.088V14.888z"/><path fill="#0F1C29" d="M99.762,26.794c-0.501,0.4-1.252,0.6-2.003,0.6c-1.954,0-3.072-1.035-3.072-3.005v-4.292h-1.47v-1.669h1.47V16.39h2.086v2.038h2.389v1.669h-2.389v4.242c0,0.868,0.435,1.334,1.236,1.334c0.434,0,0.852-0.115,1.169-0.366L99.762,26.794z"/><path fill="#0F1C29" d="M111.1,22.167v5.109h-2.087v-4.841c0-1.587-0.785-2.354-2.12-2.354c-1.486,0-2.488,0.902-2.488,2.688v4.507h-2.088V14.888h2.088v4.508c0.686-0.735,1.737-1.135,2.973-1.135C109.515,18.261,111.1,19.479,111.1,22.167z"/><path fill="#0F1C29" d="M114.089,21.433c0-3.422,2.605-5.944,6.129-5.944c1.703,0,3.239,0.568,4.274,1.704l-0.785,0.784c-0.951-0.968-2.12-1.386-3.456-1.386c-2.821,0-4.942,2.071-4.942,4.842c0,2.772,2.121,4.842,4.942,4.842c1.336,0,2.505-0.416,3.456-1.402l0.785,0.785c-1.035,1.137-2.571,1.721-4.291,1.721C116.694,27.378,114.089,24.855,114.089,21.433z"/><path fill="#0F1C29" d="M135.33,18.494v8.782h-1.136v-1.604c-0.618,1.07-1.753,1.688-3.155,1.688c-2.238,0-3.707-1.252-3.707-3.773v-5.093h1.185v4.976c0,1.871,0.97,2.822,2.639,2.822c1.837,0,2.989-1.186,2.989-3.189v-4.609H135.33z"/><path fill="#0F1C29" d="M147.137,23.253h-7.348c0.134,1.837,1.536,3.057,3.456,3.057c1.068,0,2.021-0.385,2.688-1.153l0.668,0.768c-0.784,0.936-2.003,1.436-3.389,1.436c-2.739,0-4.609-1.869-4.609-4.475c0-2.604,1.82-4.458,4.291-4.458c2.472,0,4.259,1.82,4.259,4.458C147.153,22.985,147.137,23.12,147.137,23.253z M139.789,22.368h6.228c-0.149-1.72-1.401-2.922-3.122-2.922C141.191,19.446,139.938,20.648,139.789,22.368z"/><path fill="#0F1C29" d="M149.191,26.274l0.533-0.934c0.702,0.551,1.887,0.984,3.123,0.984c1.67,0,2.354-0.568,2.354-1.436c0-2.287-5.694-0.484-5.694-3.958c0-1.436,1.236-2.504,3.474-2.504c1.136,0,2.371,0.317,3.105,0.818l-0.518,0.952c-0.769-0.534-1.687-0.751-2.588-0.751c-1.587,0-2.288,0.618-2.288,1.453c0,2.371,5.694,0.583,5.694,3.957c0,1.521-1.336,2.505-3.624,2.505C151.312,27.36,149.909,26.894,149.191,26.274z"/></g><g><path opacity=".9" fill="#4169FB" d="M26.112,36.68c-0.005,0.068-0.012,0.137-0.02,0.205c-0.006,0.039-0.009,0.078-0.016,0.115c-0.146,1.033-0.61,2.029-1.404,2.824c-1.945,1.944-5.099,1.944-7.043,0c-0.78-0.781-1.242-1.756-1.396-2.77c-0.013-0.051-0.024-0.104-0.03-0.166c-0.279-2.688-1.438-5.285-3.482-7.33c-2.015-2.014-4.567-3.17-7.214-3.469c-0.007-0.002-0.011-0.006-0.018-0.006c-1.106-0.107-2.184-0.586-3.031-1.434c-1.942-1.941-1.942-5.089,0-7.031c0.871-0.871,1.984-1.348,3.123-1.438c0.134-0.023,0.284-0.037,0.455-0.038c4.492-0.023,9.633,2.173,13.78,6.32c4.152,4.152,6.343,9.299,6.314,13.795c0,0.023,0.001,0.049,0,0.072C26.128,36.387,26.117,36.617,26.112,36.68z"/><path opacity=".9" fill="#7FD97F" d="M16.181,5.603c0.005-0.069,0.012-0.137,0.02-0.206c0.006-0.038,0.01-0.079,0.017-0.114c0.146-1.033,0.61-2.03,1.404-2.824c1.945-1.945,5.098-1.945,7.043,0c0.78,0.78,1.242,1.755,1.396,2.768c0.013,0.051,0.023,0.105,0.03,0.166c0.28,2.688,1.439,5.287,3.483,7.331c2.015,2.014,4.567,3.169,7.214,3.47c0.006,0.001,0.011,0.004,0.018,0.005c1.106,0.107,2.184,0.585,3.031,1.433c1.942,1.941,1.942,5.09,0,7.031c-0.871,0.871-1.984,1.348-3.123,1.438c-0.134,0.023-0.284,0.037-0.455,0.037c-4.492,0.023-9.633-2.172-13.78-6.319c-4.152-4.152-6.343-9.299-6.315-13.795c0-0.024,0-0.048,0-0.072C16.166,5.896,16.176,5.665,16.181,5.603z"/><path opacity=".9" fill="#64DFFD" d="M26.112,5.603c-0.005-0.069-0.012-0.137-0.02-0.206c-0.006-0.038-0.009-0.079-0.016-0.114c-0.146-1.033-0.61-2.03-1.404-2.824c-1.945-1.945-5.099-1.945-7.043,0c-0.78,0.78-1.242,1.755-1.396,2.768c-0.013,0.051-0.024,0.105-0.03,0.166c-0.279,2.688-1.438,5.287-3.482,7.331c-2.015,2.014-4.567,3.169-7.214,3.47c-0.007,0.001-0.011,0.004-0.018,0.005c-1.106,0.107-2.184,0.585-3.031,1.433c-1.942,1.941-1.942,5.09,0,7.031C3.327,25.533,4.44,26.01,5.579,26.1c0.134,0.023,0.284,0.037,0.455,0.037c4.492,0.023,9.633-2.172,13.78-6.319c4.152-4.152,6.343-9.299,6.314-13.795c0-0.024,0.001-0.048,0-0.072C26.128,5.896,26.117,5.665,26.112,5.603z"/><path opacity=".9" fill="#6BBCF1" d="M16.181,36.68c0.005,0.068,0.012,0.137,0.02,0.205c0.006,0.039,0.01,0.078,0.017,0.115c0.146,1.033,0.61,2.029,1.404,2.824c1.945,1.944,5.098,1.944,7.043,0c0.78-0.781,1.242-1.756,1.396-2.77c0.013-0.051,0.023-0.104,0.03-0.166c0.28-2.688,1.439-5.285,3.483-7.33c2.015-2.014,4.567-3.17,7.214-3.469c0.006-0.002,0.011-0.006,0.018-0.006c1.106-0.107,2.184-0.586,3.031-1.434c1.942-1.941,1.942-5.089,0-7.031c-0.871-0.871-1.984-1.348-3.123-1.438c-0.134-0.023-0.284-0.037-0.455-0.038c-4.492-0.023-9.633,2.173-13.78,6.32c-4.152,4.152-6.343,9.299-6.315,13.795c0,0.023,0,0.049,0,0.072C16.166,36.387,16.176,36.617,16.181,36.68z"/></g></g></svg>`;

// Convert SVG string to PNG data URL at high resolution via canvas
function svgToDataUrl(svgString, scale) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;
      const ctx = canvas.getContext('2d');
      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = url;
  });
}

// Brand colors
const BLUE = [0, 102, 204];
const DARK = [26, 35, 50];
const MID = [74, 85, 104];
const LIGHT_TEXT = [136, 150, 166];
const GREEN = [5, 150, 105];
const PURPLE = [124, 58, 237];
const BG_LIGHT = [248, 249, 251];
const BG_GREEN = [236, 253, 245];
const BG_BLUE = [239, 246, 255];
const WHITE = [255, 255, 255];

const PAGE_W = 215.9; // letter width mm
const PAGE_H = 279.4; // letter height mm
const M = 19; // margin mm
const CW = PAGE_W - 2 * M; // content width

function addFooter(doc, pageNum, totalPages, disclaimer, small) {
  const footerY = PAGE_H - 14;
  // Divider line
  doc.setDrawColor(...LIGHT_TEXT);
  doc.setLineWidth(0.3);
  doc.line(M, footerY - 4, PAGE_W - M, footerY - 4);
  // Disclaimer
  if (disclaimer && small) {
    doc.setFontSize(6.5);
    doc.setTextColor(...LIGHT_TEXT);
    const lines = doc.splitTextToSize(disclaimer, CW);
    doc.text(lines.slice(0, 2), M, footerY - 0.5);
  }
  // Page number
  doc.setFontSize(8);
  doc.setTextColor(...LIGHT_TEXT);
  doc.text(`Page ${pageNum} of ${totalPages}`, PAGE_W - M, footerY + 5, { align: 'right' });
  doc.text('HealthCues Workplace Health Solutions', M, footerY + 5);
}

function drawColorBox(doc, x, y, w, h, bgColor, borderColor) {
  doc.setFillColor(...bgColor);
  if (borderColor) {
    doc.setDrawColor(...borderColor);
    doc.setLineWidth(0.3);
    doc.roundedRect(x, y, w, h, 3, 3, 'FD');
  } else {
    doc.roundedRect(x, y, w, h, 3, 3, 'F');
  }
}

function addSectionHeader(doc, y, text) {
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...DARK);
  doc.text(text, M, y);
  doc.setDrawColor(...BLUE);
  doc.setLineWidth(0.8);
  doc.line(M, y + 2, M + 40, y + 2);
  return y + 10;
}

// ─── IBOS PDF Section ──────────────────────────────────────────────
function addIbosPages(doc, ibosSnapshot, companyName, employeeCount) {
  if (!ibosSnapshot || !ibosSnapshot.layers) return;
  const { layers, aggregates } = ibosSnapshot;

  // Page 1: IBOS Summary + Layer Table
  doc.addPage();
  let y = 22;
  y = addSectionHeader(doc, y, 'IBOS — Integrated Benefits Optimization Strategy');

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...MID);
  doc.text(`${companyName} · ${employeeCount} employees`, M, y);
  y += 10;

  // Hero total box
  drawColorBox(doc, M, y, CW, 26, BG_BLUE, BLUE);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...BLUE);
  doc.text('TOTAL ANNUAL OPTIMIZATION OPPORTUNITY', M + 6, y + 7);
  doc.setFontSize(22);
  doc.setTextColor(...DARK);
  doc.text(fmt(aggregates.total) + ' / year', M + 6, y + 18);
  y += 32;

  // Three-metric row
  const colW = (CW - 8) / 3;
  const metrics = [
    { label: 'Employer Savings', val: aggregates.employerSavings, bg: BG_BLUE, color: BLUE },
    { label: 'Employee Value', val: aggregates.employeeValue, bg: BG_GREEN, color: GREEN },
    { label: 'Healthcare Impact', val: aggregates.healthcareImpact, bg: [245, 243, 255], color: PURPLE },
  ];
  metrics.forEach((m, i) => {
    const x = M + i * (colW + 4);
    drawColorBox(doc, x, y, colW, 18, m.bg);
    doc.setFontSize(7);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...LIGHT_TEXT);
    doc.text(m.label.toUpperCase(), x + 3, y + 6);
    doc.setFontSize(14);
    doc.setTextColor(...m.color);
    doc.text(fmt(m.val) + '/yr', x + 3, y + 14);
  });
  y += 24;

  // Optimization by Layer table
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...DARK);
  doc.text('Optimization by Layer', M, y);
  y += 4;

  autoTable(doc, {
    startY: y,
    head: [['#', 'Component', 'Empr Save', 'Emp Value', 'Status', 'Enabled']],
    body: layers.map(l => [
      l.order || '',
      l.name,
      l.result.employerSavings > 0 ? fmt(l.result.employerSavings) : '—',
      l.result.employeeValue > 0 ? fmt(l.result.employeeValue) : '—',
      (l.effectiveStatus || 'na').toUpperCase(),
      l.effectiveEnabled ? 'Yes' : 'No',
    ]),
    foot: [[
      '', 'TOTAL (enabled layers)',
      fmt(aggregates.employerSavings),
      fmt(aggregates.employeeValue),
      '', '',
    ]],
    headStyles: { fillColor: BLUE, textColor: WHITE, fontSize: 8, fontStyle: 'bold' },
    footStyles: { fillColor: BG_LIGHT, textColor: DARK, fontSize: 8, fontStyle: 'bold' },
    bodyStyles: { fontSize: 8, textColor: MID },
    columnStyles: {
      0: { cellWidth: 10, halign: 'center' },
      2: { halign: 'right' },
      3: { halign: 'right' },
      4: { halign: 'center' },
      5: { halign: 'center' },
    },
    margin: { left: M, right: M },
    theme: 'grid',
  });

  // Page 2: Layer details
  doc.addPage();
  y = 22;
  y = addSectionHeader(doc, y, 'IBOS Layer Details');

  const enabledLayers = layers.filter(l => l.effectiveEnabled || l.effectiveStatus === 'available');
  enabledLayers.forEach(l => {
    if (y > PAGE_H - 50) {
      doc.addPage();
      y = 22;
    }
    drawColorBox(doc, M, y, CW, 6, BG_LIGHT);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...DARK);
    doc.text(`Layer ${l.order}: ${l.name}`, M + 3, y + 4);
    doc.setFontSize(8);
    doc.setTextColor(...BLUE);
    const statusLabel = (l.effectiveStatus || 'na').toUpperCase();
    doc.text(statusLabel, PAGE_W - M - 3, y + 4, { align: 'right' });
    y += 9;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...MID);
    const descLines = doc.splitTextToSize(l.shortDescription || '', CW);
    doc.text(descLines, M, y);
    y += descLines.length * 4.2 + 2;

    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...DARK);
    doc.text(
      `Employer: ${fmt(l.result.employerSavings)}/yr   Employee: ${fmt(l.result.employeeValue)}/yr`,
      M,
      y
    );
    y += 7;

    if (l.complianceNote) {
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      doc.setTextColor(...LIGHT_TEXT);
      const cn = doc.splitTextToSize('Compliance: ' + l.complianceNote, CW);
      doc.text(cn, M, y);
      y += cn.length * 4 + 2;
    }
    y += 3;
  });

  // Page 3: Roadmap
  doc.addPage();
  y = 22;
  y = addSectionHeader(doc, y, 'IBOS Implementation Roadmap');

  const phases = [
    {
      title: 'Phase 1 — Active Now',
      body: 'Section 125 + Telehealth + Pharmacy + Hospitalization + Wellness. Immediate employer FICA savings, employee take-home increase, and baseline healthcare access.',
      color: GREEN,
    },
    {
      title: 'Phase 2 — Add Section 105 HRA',
      body: 'Tax-free reimbursement of deductibles, copays, and wellness. Requires legal review and plan document. Doubles tax efficiency per dollar.',
      color: BLUE,
    },
    {
      title: 'Phase 3 — Add Direct Primary Care',
      body: 'Subscription-based primary care. Strong ROI via reduced ER/urgent care/specialist utilization. Can be funded through the Section 105 HRA.',
      color: PURPLE,
    },
  ];
  phases.forEach(p => {
    drawColorBox(doc, M, y, CW, 24, BG_LIGHT);
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...p.color);
    doc.text(p.title, M + 5, y + 6);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...MID);
    const bodyLines = doc.splitTextToSize(p.body, CW - 10);
    doc.text(bodyLines, M + 5, y + 12);
    y += 28;
  });

  // Roadmap summary
  doc.setFontSize(10);
  doc.setFont('helvetica', 'italic');
  doc.setTextColor(...DARK);
  const multiplier = aggregates.bySection125.total > 0
    ? (aggregates.byFullIBOS.total / aggregates.bySection125.total).toFixed(1)
    : '0';
  doc.text(
    `When fully implemented, IBOS delivers ${multiplier}x more total value than Section 125 alone.`,
    M,
    y + 4
  );
}

export async function generatePDF(analyzed, config, options) {
  const { companyName, preparedBy, showHcRevenue, includeIbos, ibosSnapshot, includeSavedOptions, savedOptions } = options;
  const rc = config.reportContent || {};
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter' });
  const eligible = analyzed.filter(e => e.hasViable);
  const notRecommended = analyzed.filter(e => !e.hasViable);
  const totalEmprFica = eligible.reduce((s, e) => s + e.optimal.employerAnnualFica, 0);
  const totalEmpBenefit = eligible.reduce((s, e) => s + e.optimal.employeeAnnualBenefit, 0);
  const totalHcRevenue = eligible.reduce((s, e) => s + e.optimal.hcAnnualRevenue, 0);
  const avgSalary = eligible.length > 0 ? eligible.reduce((s, e) => s + e.salary, 0) / eligible.length : 40000;
  const avgFicaPerEmp = eligible.length > 0 ? totalEmprFica / eligible.length : 0;
  const avgEmpMonthly = eligible.length > 0 ? totalEmpBenefit / eligible.length / 12 : 0;
  const dateStr = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  // Count pages for footer (estimate, we'll patch later)
  let totalPages = 10;

  // ==================== PAGE 1: COVER ====================
  // Background accent bar
  doc.setFillColor(...BLUE);
  doc.rect(0, 0, PAGE_W, 8, 'F');
  doc.setFillColor(...GREEN);
  doc.rect(0, PAGE_H - 8, PAGE_W, 8, 'F');

  // HealthCues logo - convert SVG to PNG and render
  const cx = PAGE_W / 2;
  try {
    const logoDataUrl = await svgToDataUrl(LOGO_SVG, 4); // High scale for crisp rendering
    const logoWidth = 50; // mm
    const logoHeight = (42 / 157) * logoWidth; // Preserve aspect ratio (original: 157×42)
    const logoX = cx - logoWidth / 2;
    const logoY = 75;
    doc.addImage(logoDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight);
  } catch (err) {
    // Fallback to placeholder circle if logo conversion fails
    console.warn('Logo rendering failed, using fallback:', err);
    doc.setFillColor(...BG_BLUE);
    doc.circle(cx, 85, 22, 'F');
    doc.setFontSize(28);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...BLUE);
    doc.text('HC', cx, 90, { align: 'center' });
  }

  // Title
  doc.setFontSize(32);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...DARK);
  doc.text(rc.report_title || 'Section 125 Benefits Analysis', cx, 130, { align: 'center' });

  // Subtitle
  doc.setFontSize(16);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...MID);
  doc.text(`${rc.report_subtitle_prefix || 'Prepared for'} ${companyName}`, cx, 145, { align: 'center' });

  // Date
  doc.setFontSize(12);
  doc.text(dateStr, cx, 158, { align: 'center' });

  if (preparedBy) {
    doc.setFontSize(11);
    doc.text(`Prepared by: ${preparedBy}`, cx, 168, { align: 'center' });
  }

  // Confidentiality
  doc.setFontSize(9);
  doc.setTextColor(...LIGHT_TEXT);
  doc.text(rc.confidentiality_notice || '', cx, PAGE_H - 25, { align: 'center' });

  // ==================== PAGE 2: EXECUTIVE SUMMARY ====================
  doc.addPage();
  let y = M + 5;
  y = addSectionHeader(doc, y, rc.exec_summary_headline || 'Executive Summary');

  // Intro
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...MID);
  const introLines = doc.splitTextToSize(rc.exec_summary_intro || '', CW);
  doc.text(introLines, M, y);
  y += introLines.length * 5 + 8;

  // Hero stats
  const stats = [
    { label: 'Total Employees Analyzed', value: String(analyzed.length), color: DARK },
    { label: 'Eligible Employees', value: `${eligible.length} (${fmtPct(eligible.length / analyzed.length)})`, color: GREEN },
    { label: 'Annual Employer FICA Savings', value: fmt(totalEmprFica), color: BLUE, hero: true },
    { label: 'Avg FICA Savings / Employee / Year', value: fmt(avgFicaPerEmp), color: BLUE },
    { label: 'Total Annual Employee Take-Home Increase', value: fmt(totalEmpBenefit), color: GREEN },
    { label: 'Avg Monthly Take-Home Increase / Employee', value: fmt(avgEmpMonthly), color: GREEN },
  ];
  if (showHcRevenue) {
    stats.push({ label: 'Total Annual HC Spread Revenue', value: fmt(totalHcRevenue), color: PURPLE });
  }

  // Hero stat - big FICA savings
  drawColorBox(doc, M, y, CW, 32, BG_BLUE, BLUE);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...BLUE);
  doc.text('TOTAL ANNUAL EMPLOYER FICA SAVINGS', cx, y + 10, { align: 'center' });
  doc.setFontSize(28);
  doc.setFont('helvetica', 'bold');
  doc.text(fmt(totalEmprFica), cx, y + 25, { align: 'center' });
  y += 38;

  // Other stats in grid
  const statW = (CW - 8) / 3;
  const STAT_BOX_H = 24; // bumped from 20 → 24 to give multi-line labels room to wrap
  const otherStats = stats.filter(s => !s.hero);
  otherStats.forEach((stat, i) => {
    const col = i % 3;
    const row = Math.floor(i / 3);
    const sx = M + col * (statW + 4);
    const sy = y + row * (STAT_BOX_H + 4);
    drawColorBox(doc, sx, sy, statW, STAT_BOX_H, BG_LIGHT);
    // Wrap the label to fit the box width (with 4mm padding each side).
    // Long labels like "TOTAL ANNUAL EMPLOYEE TAKE-HOME INCREASE" otherwise
    // run past the card border into the neighboring tile.
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...LIGHT_TEXT);
    const labelLines = doc.splitTextToSize(stat.label.toUpperCase(), statW - 6);
    const labelLineH = 3.2;
    const labelBlockH = labelLines.length * labelLineH;
    // Keep label top-aligned within the card; value sits in the lower portion
    labelLines.forEach((line, li) => {
      doc.text(line, sx + statW / 2, sy + 5 + li * labelLineH, { align: 'center' });
    });
    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...stat.color);
    doc.text(stat.value, sx + statW / 2, sy + Math.max(5 + labelBlockH + 7, STAT_BOX_H - 5), { align: 'center' });
  });
  y += Math.ceil(otherStats.length / 3) * (STAT_BOX_H + 4) + 8;

  // Callout boxes
  if (rc.exec_summary_employer_callout) {
    drawColorBox(doc, M, y, CW, 16, BG_GREEN, GREEN);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...GREEN);
    doc.text(rc.exec_summary_employer_callout, M + 5, y + 10, { maxWidth: CW - 10 });
    y += 22;
  }
  if (rc.exec_summary_employee_callout) {
    drawColorBox(doc, M, y, CW, 16, BG_BLUE, BLUE);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...BLUE);
    doc.text(rc.exec_summary_employee_callout, M + 5, y + 10, { maxWidth: CW - 10 });
    y += 22;
  }

  addFooter(doc, 2, totalPages, rc.report_disclaimer, true);

  // ==================== PAGE 3: HOW IT WORKS ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.how_it_works_headline || 'How the Program Works');

  doc.setFontSize(10.5);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...MID);
  const bodyText = (rc.how_it_works_body || '').replace(/\\n/g, '\n');
  const bodyParagraphs = bodyText.split('\n\n');
  bodyParagraphs.forEach(para => {
    const lines = doc.splitTextToSize(para.trim(), CW);
    doc.text(lines, M, y);
    y += lines.length * 4.5 + 4;
  });

  y += 4;
  // Steps
  const steps = rc.how_it_works_steps || [];
  steps.forEach((step, i) => {
    // Step number circle
    doc.setFillColor(...BLUE);
    doc.circle(M + 5, y + 2, 4, 'F');
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...WHITE);
    doc.text(String(i + 1), M + 5, y + 3.5, { align: 'center' });
    // Description
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...DARK);
    const stepLines = doc.splitTextToSize(step.description || '', CW - 18);
    doc.text(stepLines, M + 14, y + 3);
    y += Math.max(stepLines.length * 4.5, 10) + 3;
  });

  // Avg paycheck example
  y += 6;
  if (eligible.length > 0) {
    const avgState = eligible[0].state || 'CA';
    const avgFiling = 'single';
    const optimalTier = eligible[0].optimal;
    const calc = calculateScenario(Math.round(avgSalary), avgState, avgFiling, optimalTier.monthlyPremium, optimalTier.monthlyClaim, config);
    
    drawColorBox(doc, M, y, CW, 8, BLUE);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...WHITE);
    doc.text(`AVERAGE EMPLOYEE PAYCHECK EXAMPLE (${fmt(Math.round(avgSalary))}/yr)`, M + 5, y + 5.5);
    y += 10;

    const exRows = [
      ['Gross Monthly Income', fmt(calc.without.gross), fmt(calc.with125.gross)],
      ['Pre-tax Premium', '$0.00', fmt(calc.with125.premium)],
      ['Total Tax Withholding', fmt(calc.without.totalTax), fmt(calc.with125.totalTax)],
      ['Claim Payment', '$0.00', fmt(calc.with125.claim)],
      ['Net Take Home Pay', fmt(calc.without.netTakeHome), fmt(calc.with125.netTakeHome)],
    ];
    autoTable(doc, {
      startY: y,
      margin: { left: M, right: M },
      head: [['', 'Without HealthCues', 'With HealthCues']],
      body: exRows,
      styles: { fontSize: 9, cellPadding: 2.5, textColor: MID },
      headStyles: { fillColor: BG_LIGHT, textColor: DARK, fontStyle: 'bold', fontSize: 8 },
      columnStyles: { 0: { fontStyle: 'bold', textColor: DARK }, 1: { halign: 'right' }, 2: { halign: 'right' } },
      alternateRowStyles: { fillColor: [252, 252, 254] },
      theme: 'plain',
    });
  }

  addFooter(doc, 3, totalPages, rc.report_disclaimer, true);

  // ==================== PAGE 4: EMPLOYER BENEFITS ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.employer_benefits_headline || 'Benefits to Your Organization');

  const empBenefits = rc.employer_benefits_items || [];
  empBenefits.forEach((item, i) => {
    if (y > PAGE_H - 50) { doc.addPage(); y = M + 5; }
    drawColorBox(doc, M, y, CW, 22, i % 2 === 0 ? BG_BLUE : BG_GREEN);
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...DARK);
    doc.text(item.title || '', M + 5, y + 7);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...MID);
    const descLines = doc.splitTextToSize(item.description || '', CW - 10);
    doc.text(descLines, M + 5, y + 13);
    y += Math.max(22, 13 + descLines.length * 4) + 4;
  });

  // FICA callout
  y += 4;
  drawColorBox(doc, M, y, CW, 26, BG_GREEN, GREEN);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...GREEN);
  doc.text(`${companyName.toUpperCase()}'S ANNUAL FICA SAVINGS`, cx, y + 8, { align: 'center' });
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.text(fmt(totalEmprFica), cx, y + 20, { align: 'center' });

  addFooter(doc, 4, totalPages, rc.report_disclaimer, true);

  // ==================== PAGE 5: EMPLOYEE BENEFITS ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.employee_benefits_headline || 'What Your Employees Receive');

  doc.setFontSize(10.5);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...MID);
  const empIntroLines = doc.splitTextToSize(rc.employee_benefits_intro || '', CW);
  doc.text(empIntroLines, M, y);
  y += empIntroLines.length * 4.5 + 8;

  const categories = rc.employee_benefits_categories || [];
  const catColW = (CW - 8) / 2;
  categories.forEach((cat, i) => {
    const col = i % 2;
    const sx = M + col * (catColW + 8);
    if (col === 0 && i > 0) y += 30;
    if (i === 0 || col === 0) { /* new row */ }
    const sy = y;
    drawColorBox(doc, sx, sy, catColW, 26, i % 4 < 2 ? BG_BLUE : BG_GREEN);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...DARK);
    doc.text(cat.title || '', sx + 4, sy + 8);
    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...MID);
    const catLines = doc.splitTextToSize(cat.description || '', catColW - 8);
    doc.text(catLines, sx + 4, sy + 14);
  });
  if (categories.length % 2 === 1) y += 30;
  else y += 30;

  addFooter(doc, 5, totalPages, rc.report_disclaimer, true);

  // ==================== PAGE 6: PLAN OPTIONS ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.plan_options_headline || 'Available Plan Options');

  doc.setFontSize(10.5);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...MID);
  const planIntroLines = doc.splitTextToSize(rc.plan_options_intro || '', CW);
  doc.text(planIntroLines, M, y);
  y += planIntroLines.length * 4.5 + 6;

  const planHead = [['Plan', 'Premium/Mo', 'Claim/Mo', 'Spread/Mo', 'Benefits']];
  const planBody = (config.planTiers || []).filter(t => !t.archived).map(t => {
    const benefitSummary = (t.benefits || []).map(b => `${b.name}: $${b.fee}/${b.unit} × ${b.quantity}`).join('; ');
    return [t.label, fmt(t.monthlyPremium), fmt(t.monthlyClaim), fmt(t.spread), benefitSummary];
  });
  autoTable(doc, {
    startY: y,
    margin: { left: M, right: M },
    head: planHead,
    body: planBody,
    styles: { fontSize: 8.5, cellPadding: 3, textColor: MID },
    headStyles: { fillColor: BLUE, textColor: WHITE, fontStyle: 'bold', fontSize: 8 },
    columnStyles: { 0: { fontStyle: 'bold', textColor: DARK }, 1: { halign: 'right' }, 2: { halign: 'right' }, 3: { halign: 'right', textColor: PURPLE }, 4: { fontSize: 7, cellWidth: 55 } },
    alternateRowStyles: { fillColor: [248, 249, 251] },
    theme: 'plain',
  });

  addFooter(doc, 6, totalPages, rc.report_disclaimer, true);

  // ==================== PAGE 7: PAYCHECK COMPARISON ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.paycheck_headline || 'Monthly Paycheck Example');

  if (eligible.length > 0) {
    const avgState = eligible[0].state || 'CA';
    const avgFiling = 'single';
    const optimalTier = eligible[0].optimal;
    const calc = calculateScenario(Math.round(avgSalary), avgState, avgFiling, optimalTier.monthlyPremium, optimalTier.monthlyClaim, config);

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...MID);
    doc.text(`Based on average workforce salary of ${fmt(Math.round(avgSalary))}/year in ${config.stateData[avgState]?.name || avgState}`, M, y);
    y += 8;

    const rows = [
      ['Gross Monthly Income', fmt(calc.without.gross), fmt(calc.with125.gross), '$0.00'],
      ['HealthCues Pre-tax Premium', '$0.00', fmt(calc.with125.premium), fmt(calc.with125.premium)],
      ['Taxable Income', fmt(calc.without.gross), fmt(calc.with125.taxableIncome), fmt(calc.without.gross - calc.with125.taxableIncome)],
      ['', '', '', ''],
      ['Federal Tax', fmt(calc.without.federalTax), fmt(calc.with125.federalTax), fmt(calc.diff.federalTax)],
      ['Social Security', fmt(calc.without.socialSecurity), fmt(calc.with125.socialSecurity), fmt(calc.diff.socialSecurity)],
      ['Medicare', fmt(calc.without.medicare), fmt(calc.with125.medicare), fmt(calc.diff.medicare)],
      ['State Tax', fmt(calc.without.stateTax), fmt(calc.with125.stateTax), fmt(calc.diff.stateTax)],
      ['Total Tax Withholding', fmt(calc.without.totalTax), fmt(calc.with125.totalTax), fmt(calc.diff.totalTax)],
      ['', '', '', ''],
      ['HealthCues Claim Payment', '$0.00', fmt(calc.with125.claim), fmt(calc.with125.claim)],
      ['NET TAKE HOME PAY', fmt(calc.without.netTakeHome), fmt(calc.with125.netTakeHome), fmt(calc.diff.netTakeHome)],
    ];

    autoTable(doc, {
      startY: y,
      margin: { left: M, right: M },
      head: [['', 'Without HealthCues', 'With HealthCues', 'Difference']],
      body: rows,
      styles: { fontSize: 9, cellPadding: 2.5, textColor: MID },
      headStyles: { fillColor: BLUE, textColor: WHITE, fontStyle: 'bold', fontSize: 8.5 },
      columnStyles: { 0: { fontStyle: 'bold', textColor: DARK, cellWidth: 55 }, 1: { halign: 'right' }, 2: { halign: 'right' }, 3: { halign: 'right' } },
      theme: 'plain',
      didParseCell: function(data) {
        if (data.section === 'body') {
          // Highlight NET TAKE HOME row
          if (data.row.index === rows.length - 1) {
            data.cell.styles.fillColor = BG_GREEN;
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.textColor = GREEN;
          }
          // Highlight total tax row
          if (data.row.index === 8) {
            data.cell.styles.fontStyle = 'bold';
          }
          // Empty separator rows
          if (rows[data.row.index][0] === '') {
            data.cell.styles.cellPadding = 1;
            data.cell.styles.fontSize = 4;
          }
          // Green color for positive differences
          if (data.column.index === 3 && data.row.index !== rows.length - 1 && rows[data.row.index][0] !== '') {
            data.cell.styles.textColor = GREEN;
          }
        }
      },
    });
    y = (doc).lastAutoTable.finalY + 8;

    // Impact summary boxes
    const boxW = (CW - 8) / 3;
    [
      { label: 'Monthly Increase', value: '+' + fmt(calc.diff.netTakeHome), bg: BG_GREEN, color: GREEN },
      { label: 'Annual Increase', value: '+' + fmt(calc.diff.netTakeHome * 12), bg: BG_GREEN, color: GREEN },
      { label: 'Tax Savings/Mo', value: fmt(calc.diff.totalTax), bg: BG_BLUE, color: BLUE },
    ].forEach((box, i) => {
      const bx = M + i * (boxW + 4);
      drawColorBox(doc, bx, y, boxW, 20, box.bg);
      doc.setFontSize(7);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...LIGHT_TEXT);
      doc.text(box.label.toUpperCase(), bx + boxW / 2, y + 7, { align: 'center' });
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...box.color);
      doc.text(box.value, bx + boxW / 2, y + 16, { align: 'center' });
    });
    y += 26;
  }

  if (rc.paycheck_footnote) {
    doc.setFontSize(7.5);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(...LIGHT_TEXT);
    const fnLines = doc.splitTextToSize(rc.paycheck_footnote, CW);
    doc.text(fnLines, M, y);
  }

  addFooter(doc, 7, totalPages, rc.report_disclaimer, true);

  // ==================== PAGE 8: FINANCIAL IMPACT ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.financial_impact_headline || "Your Organization's Financial Impact");

  // Summary table
  const totalPremiums = eligible.reduce((s, e) => s + e.optimal.monthlyPremium, 0);
  const totalGross = eligible.reduce((s, e) => s + e.salary / 12, 0);
  const emprFicaWithout = totalGross * config.payrollConstants.employerFicaRate;
  const emprFicaWith = (totalGross - totalPremiums) * config.payrollConstants.employerFicaRate;

  const finRows = [
    ['Eligible Employees', String(eligible.length), '', ''],
    ['Total Monthly Gross Income', fmt(totalGross), fmt(totalGross), '$0.00'],
    ['Total Monthly Pre-tax Premiums', '$0.00', fmt(totalPremiums), fmt(totalPremiums)],
    ['Monthly FICA-Taxable Payroll', fmt(totalGross), fmt(totalGross - totalPremiums), fmt(totalPremiums)],
    ['Monthly Employer FICA (7.65%)', fmt(emprFicaWithout), fmt(emprFicaWith), fmt(emprFicaWithout - emprFicaWith)],
    ['ANNUAL EMPLOYER FICA SAVINGS', '', '', fmt(totalEmprFica)],
  ];

  autoTable(doc, {
    startY: y,
    margin: { left: M, right: M },
    head: [['', 'Without HealthCues', 'With HealthCues', 'Savings']],
    body: finRows,
    styles: { fontSize: 9, cellPadding: 3, textColor: MID },
    headStyles: { fillColor: BLUE, textColor: WHITE, fontStyle: 'bold', fontSize: 8.5 },
    columnStyles: { 0: { fontStyle: 'bold', textColor: DARK, cellWidth: 60 }, 1: { halign: 'right' }, 2: { halign: 'right' }, 3: { halign: 'right', textColor: GREEN } },
    theme: 'plain',
    didParseCell: function(data) {
      if (data.section === 'body' && data.row.index === finRows.length - 1) {
        data.cell.styles.fillColor = BG_GREEN;
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.textColor = GREEN;
        data.cell.styles.fontSize = 11;
      }
    },
  });
  y = (doc).lastAutoTable.finalY + 10;

  // Plan tier breakdown
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...DARK);
  doc.text('Savings by Plan Tier', M, y);
  y += 6;

  const tierBreakdown = {};
  eligible.forEach(e => {
    const key = e.optimal.label;
    if (!tierBreakdown[key]) tierBreakdown[key] = { count: 0, fica: 0 };
    tierBreakdown[key].count++;
    tierBreakdown[key].fica += e.optimal.employerAnnualFica;
  });

  const tierRows = Object.entries(tierBreakdown).map(([label, data]) => [
    label, String(data.count), fmt(data.fica / data.count), fmt(data.fica)
  ]);
  tierRows.push(['TOTAL', String(eligible.length), fmt(avgFicaPerEmp), fmt(totalEmprFica)]);

  autoTable(doc, {
    startY: y,
    margin: { left: M, right: M },
    head: [['Plan', 'Employees', 'Avg FICA/Employee', 'Total Annual FICA']],
    body: tierRows,
    styles: { fontSize: 9, cellPadding: 2.5, textColor: MID },
    headStyles: { fillColor: BG_LIGHT, textColor: DARK, fontStyle: 'bold', fontSize: 8 },
    columnStyles: { 1: { halign: 'center' }, 2: { halign: 'right' }, 3: { halign: 'right', fontStyle: 'bold', textColor: GREEN } },
    theme: 'plain',
    didParseCell: function(data) {
      if (data.section === 'body' && data.row.index === tierRows.length - 1) {
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.fillColor = BG_GREEN;
        data.cell.styles.textColor = GREEN;
      }
    },
  });

  if (rc.financial_impact_footnote) {
    const fnY = (doc).lastAutoTable.finalY + 8;
    doc.setFontSize(7.5);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(...LIGHT_TEXT);
    doc.text(doc.splitTextToSize(rc.financial_impact_footnote, CW), M, fnY);
  }

  addFooter(doc, 8, totalPages, rc.report_disclaimer, true);

  // ==================== RECOMMENDATIONS PAGE (positive-ROI only) ====================
  // Surfaces actionable recommendations the employer can take to convert
  // currently-ineligible employees, but only those where the action's FICA
  // recovery exceeds (or equals) its cost. 1099-reclass / union / seasonal
  // recommendations are intentionally excluded — see positiveRecommendations.js.
  const positiveRecs = computePositiveRecommendations(analyzed, config);
  if (positiveRecs.length > 0) {
    doc.addPage();
    let recY = M + 5;
    recY = addSectionHeader(doc, recY, 'Recommendations to Increase Participation');

    // Intro callout
    doc.setFillColor(...BG_GREEN);
    doc.roundedRect(M, recY, CW, 14, 2, 2, 'F');
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...DARK);
    const totalRecFica = positiveRecs.reduce((s, r) => s + (r.totalAnnualFica || 0), 0);
    const totalRecCount = positiveRecs.reduce((s, r) => s + (r.positiveRoiCount || 0), 0);
    const introLines = doc.splitTextToSize(
      `${totalRecCount} additional employee${totalRecCount === 1 ? '' : 's'} could be added to the program through ${positiveRecs.length} action${positiveRecs.length === 1 ? '' : 's'} below — each one is net-positive ROI for the employer (FICA recovery ≥ cost). Combined potential: ${fmt(totalRecFica)}/year in additional employer FICA savings.`,
      CW - 6
    );
    doc.text(introLines, M + 3, recY + 5);
    recY += 14 + 6;

    const IMPACT_BADGE = {
      high: { fill: GREEN, text: 'HIGH IMPACT' },
      medium: { fill: PURPLE, text: 'MEDIUM IMPACT' },
      low: { fill: BLUE, text: 'LOW IMPACT' },
      informational: { fill: LIGHT_TEXT, text: 'INFORMATIONAL' },
    };

    positiveRecs.forEach((rec, i) => {
      // Page-break safety
      const estCardHeight = 30 + (rec.scenarios?.length ? rec.scenarios.length * 5 : 0) + (rec.rows?.length ? Math.min(rec.rows.length, 8) * 5 : 0);
      if (recY + estCardHeight > PAGE_H - 25) {
        doc.addPage();
        recY = M + 5;
        recY = addSectionHeader(doc, recY, 'Recommendations to Increase Participation (continued)');
      }

      // Card border
      const cardTop = recY;
      doc.setDrawColor(...LIGHT_TEXT);
      doc.setLineWidth(0.2);

      // Title row + impact badge
      doc.setFontSize(11.5);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...DARK);
      doc.text(`${i + 1}. ${rec.title}`, M + 3, recY + 5);
      const badge = IMPACT_BADGE[rec.impact] || IMPACT_BADGE.medium;
      const badgeText = badge.text;
      const badgeW = doc.getTextWidth(badgeText) + 6;
      doc.setFillColor(...badge.fill);
      doc.roundedRect(PAGE_W - M - badgeW - 3, recY + 1.5, badgeW, 5, 1, 1, 'F');
      doc.setFontSize(7);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...WHITE);
      doc.text(badgeText, PAGE_W - M - badgeW - 3 + badgeW / 2, recY + 5, { align: 'center' });
      recY += 9;

      // Headline
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...MID);
      const headlineLines = doc.splitTextToSize(rec.headline || '', CW - 6);
      doc.text(headlineLines, M + 3, recY);
      recY += headlineLines.length * 4 + 2;

      // Stat strip — count + FICA
      doc.setFillColor(...BG_GREEN);
      doc.roundedRect(M + 3, recY, CW - 6, 9, 1.5, 1.5, 'F');
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...GREEN);
      doc.text(`+${rec.positiveRoiCount} eligible employees`, M + 6, recY + 5.5);
      doc.text(`${fmt(rec.totalAnnualFica)}/year FICA savings`, PAGE_W - M - 6, recY + 5.5, { align: 'right' });
      recY += 12;

      // Scenarios table (waiting / hours)
      if (rec.scenarios && rec.scenarios.length > 0) {
        autoTable(doc, {
          startY: recY,
          margin: { left: M + 3, right: M + 3 },
          head: [['Scenario', 'Newly Eligible', 'Annual FICA']],
          body: rec.scenarios.map((s) => [s.label, `+${s.count}`, fmt(s.fica)]),
          styles: { fontSize: 8.5, cellPadding: 2, textColor: MID },
          headStyles: { fillColor: BG_LIGHT, textColor: DARK, fontStyle: 'bold', fontSize: 8 },
          columnStyles: {
            0: { fontStyle: 'bold', textColor: DARK },
            1: { halign: 'center' },
            2: { halign: 'right', fontStyle: 'bold', textColor: GREEN },
          },
          theme: 'plain',
        });
        recY = doc.lastAutoTable.finalY + 2;
      }

      // Rows table (near-eligible employees)
      if (rec.rows && rec.rows.length > 0) {
        const cap = Math.min(rec.rows.length, 8);
        const body = rec.rows.slice(0, cap).map((r) => [
          r.name,
          fmt(r.salary),
          `+${fmt(r.gap)}/yr ($${Math.round(r.monthlyGap)}/mo)`,
          fmt(r.ficaSavings),
          `+${fmt(r.netImpact)}`,
        ]);
        if (rec.rows.length > cap) {
          body.push([`+ ${rec.rows.length - cap} more`, '', '', '', '']);
        }
        autoTable(doc, {
          startY: recY,
          margin: { left: M + 3, right: M + 3 },
          head: [['Employee', 'Current Salary', 'Raise Needed', 'FICA Saved', 'Net Impact']],
          body,
          styles: { fontSize: 8.5, cellPadding: 1.8, textColor: MID },
          headStyles: { fillColor: BG_LIGHT, textColor: DARK, fontStyle: 'bold', fontSize: 8 },
          columnStyles: {
            0: { fontStyle: 'bold', textColor: DARK, cellWidth: 38 },
            1: { halign: 'right' },
            2: { halign: 'right' },
            3: { halign: 'right', textColor: GREEN },
            4: { halign: 'right', fontStyle: 'bold', textColor: GREEN },
          },
          theme: 'plain',
        });
        recY = doc.lastAutoTable.finalY + 2;
      }

      // Rationale footnote
      if (rec.rationale) {
        doc.setFontSize(7.5);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(...LIGHT_TEXT);
        const rationaleLines = doc.splitTextToSize(rec.rationale, CW - 6);
        doc.text(rationaleLines, M + 3, recY + 1);
        recY += rationaleLines.length * 3.2 + 4;
      }

      // Card outline (drawn last so it wraps everything)
      doc.setDrawColor(...LIGHT_TEXT);
      doc.setLineWidth(0.15);
      doc.roundedRect(M, cardTop - 2, CW, recY - cardTop + 1, 2, 2);
      recY += 6;
    });

    addFooter(doc, 9, totalPages, rc.report_disclaimer, true);
  }

  // ==================== PAGE 9+: EMPLOYEE ROSTER ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.roster_headline || 'Employee-Level Analysis');

  const rosterHead = showHcRevenue
    ? [['Name', 'Dept', 'Salary', 'Filing', 'Plan', 'Emp Net/Mo', 'Emp Net/Yr', 'Empr FICA/Yr', 'HC Rev/Yr', 'Status']]
    : [['Name', 'Dept', 'Salary', 'Filing', 'Plan', 'Tax Save/Mo', 'Emp Net/Mo', 'Emp Net/Yr', 'Empr FICA/Yr', 'Status']];

  const rosterBody = analyzed.map(e => {
    const filingAbbr = fmtFiling(e.filing);
    if (e.hasViable) {
      const o = e.optimal;
      return showHcRevenue
        ? [e.name, e.department || '-', fmt(e.salary), filingAbbr, o.label, '+' + fmt(o.employeePerPeriodBenefit), '+' + fmt(o.employeeAnnualBenefit), fmt(o.employerAnnualFica), fmt(o.hcAnnualRevenue), 'Eligible']
        : [e.name, e.department || '-', fmt(e.salary), filingAbbr, o.label, fmt(o.calc.diff.totalTax), '+' + fmt(o.employeePerPeriodBenefit), '+' + fmt(o.employeeAnnualBenefit), fmt(o.employerAnnualFica), 'Eligible'];
    }
    return showHcRevenue
      ? [e.name, e.department || '-', fmt(e.salary), filingAbbr, 'None', '-', '-', '-', '-', `Need ${fmt(e.breakEvenSalary)}`]
      : [e.name, e.department || '-', fmt(e.salary), filingAbbr, 'None', '-', '-', '-', '-', `Need ${fmt(e.breakEvenSalary)}`];
  });

  // Add totals row
  if (showHcRevenue) {
    rosterBody.push(['TOTALS', '', '', '', '', '+' + fmt(totalEmpBenefit / 12), '+' + fmt(totalEmpBenefit), fmt(totalEmprFica), fmt(totalHcRevenue), `${eligible.length} eligible`]);
  } else {
    rosterBody.push(['TOTALS', '', '', '', '', '', '+' + fmt(totalEmpBenefit / 12), '+' + fmt(totalEmpBenefit), fmt(totalEmprFica), `${eligible.length} eligible`]);
  }

  autoTable(doc, {
    startY: y,
    margin: { left: M, right: M },
    head: rosterHead,
    body: rosterBody,
    styles: { fontSize: 7.5, cellPadding: 2, textColor: MID },
    headStyles: { fillColor: BLUE, textColor: WHITE, fontStyle: 'bold', fontSize: 7 },
    columnStyles: { 0: { textColor: DARK, fontStyle: 'bold' }, 2: { halign: 'right' }, 3: { halign: 'center', fontStyle: 'bold' } },
    alternateRowStyles: { fillColor: [248, 249, 251] },
    theme: 'plain',
    didParseCell: function(data) {
      if (data.section === 'body') {
        // Total row
        if (data.row.index === rosterBody.length - 1) {
          data.cell.styles.fillColor = BG_GREEN;
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.textColor = GREEN;
        }
        // Not eligible rows
        const statusCol = showHcRevenue ? 9 : 9;
        if (data.column.index === statusCol) {
          const val = rosterBody[data.row.index]?.[statusCol] || '';
          if (val.startsWith('Need')) {
            data.cell.styles.textColor = [220, 38, 38];
            data.cell.styles.fontSize = 6.5;
          } else if (val === 'Eligible') {
            data.cell.styles.textColor = GREEN;
          }
        }
      }
    },
  });

  // Get current page for roster
  let rosterEndPage = doc.internal.getNumberOfPages();

  addFooter(doc, rosterEndPage, totalPages, rc.report_disclaimer, true);

  // ==================== FINAL PAGE: NEXT STEPS ====================
  doc.addPage();
  y = M + 5;
  y = addSectionHeader(doc, y, rc.next_steps_headline || 'Getting Started is Simple');

  const nextSteps = rc.next_steps_items || [];
  nextSteps.forEach((step, i) => {
    drawColorBox(doc, M, y, CW, 22, i % 2 === 0 ? BG_BLUE : BG_GREEN);
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...DARK);
    doc.text(step.title || '', M + 5, y + 8);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...MID);
    const stepLines = doc.splitTextToSize(step.description || '', CW - 10);
    doc.text(stepLines, M + 5, y + 14);
    y += 26;
  });

  if (rc.next_steps_timeline) {
    y += 2;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(...MID);
    doc.text(rc.next_steps_timeline, M, y);
    y += 10;
  }

  // Contact info
  y += 6;
  drawColorBox(doc, M, y, CW, 40, BG_LIGHT);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...DARK);
  doc.text(rc.contact_name || 'HealthCues', M + 5, y + 10);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...MID);
  let cy = y + 18;
  if (rc.contact_phone) { doc.text(rc.contact_phone, M + 5, cy); cy += 5.5; }
  if (rc.contact_email) { doc.text(rc.contact_email, M + 5, cy); cy += 5.5; }
  if (rc.contact_website) { doc.text(rc.contact_website, M + 5, cy); }
  y += 48;

  // Closing message
  if (rc.closing_message) {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...BLUE);
    const closeLines = doc.splitTextToSize(rc.closing_message, CW);
    doc.text(closeLines, cx, y, { align: 'center' });
  }

  // ─── Optional IBOS Pages ───────────────────────────────────────────
  if (includeIbos && ibosSnapshot && ibosSnapshot.layers) {
    addIbosPages(doc, ibosSnapshot, companyName, analyzed.length);
  }

  // ─── Optional Saved Options Comparison Page ───────────────────────
  if (includeSavedOptions && savedOptions && savedOptions.options && savedOptions.options.length >= 2) {
    addSavedOptionsPage(doc, savedOptions, companyName);
  }

  // Fix total pages and re-add footers
  totalPages = doc.internal.getNumberOfPages();
  for (let i = 2; i <= totalPages; i++) {
    doc.setPage(i);
    addFooter(doc, i, totalPages, rc.report_disclaimer, true);
  }

  // Save PDF - using multiple strategies for compatibility
  const fileName = `HealthCues-Analysis-${companyName.replace(/[^a-zA-Z0-9]/g, '-')}.pdf`;
  
  try {
    // Strategy 1: Blob URL with <a download>
    const blob = doc.output('blob');
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.target = '_blank';
    link.rel = 'noopener';
    link.style.cssText = 'position:fixed;left:-9999px;';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }, 5000);
  } catch (e) {
    // Strategy 2: Open data URI in new tab
    try {
      const dataUri = doc.output('datauristring');
      window.open(dataUri, '_blank');
    } catch (e2) {
      // Strategy 3: Direct jsPDF save
      doc.save(fileName);
    }
  }
}


// ─── Saved Options Comparison Page (PDF) ─────────────────────────
function addSavedOptionsPage(doc, savedOptions, companyName) {
  doc.addPage();
  const margin = 18;
  let y = 20;

  // Header
  doc.setFillColor(...BLUE);
  doc.rect(0, 0, PAGE_W, 8, 'F');
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(20, 30, 50);
  doc.text('Benefit Options Comparison', margin, y);
  y += 7;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(100, 110, 130);
  doc.text(companyName, margin, y);
  y += 4;
  if (savedOptions.createdAt) {
    doc.text(`Saved options · Generated ${new Date(savedOptions.createdAt).toLocaleDateString()}`, margin, y);
  }
  y += 10;

  const options = savedOptions.options || [];
  if (options.length === 0) return;

  // Side-by-side option cards
  const cardW = (PAGE_W - 2 * margin - 6) / 2;
  const cardH = 80;
  options.slice(0, 2).forEach((opt, i) => {
    const x = margin + i * (cardW + 6);
    const isRec = opt.badge === 'recommended';
    if (isRec) {
      doc.setDrawColor(...BLUE);
      doc.setLineWidth(0.6);
    } else {
      doc.setDrawColor(220, 224, 230);
      doc.setLineWidth(0.3);
    }
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(x, y, cardW, cardH, 3, 3, 'FD');

    // Badge
    const badgeBg = isRec ? BLUE : [220, 220, 220];
    doc.setFillColor(...badgeBg);
    doc.roundedRect(x + 6, y + 6, isRec ? 30 : 18, 5, 1, 1, 'F');
    doc.setFontSize(7);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.text(isRec ? 'RECOMMENDED' : 'CURRENT', x + (isRec ? 21 : 15), y + 9.5, { align: 'center' });

    // Option label + title
    doc.setFontSize(8);
    doc.setTextColor(120, 130, 145);
    doc.setFont('helvetica', 'bold');
    doc.text(opt.label, x + 6, y + 18);
    doc.setFontSize(13);
    doc.setTextColor(20, 30, 50);
    doc.text(opt.title, x + 6, y + 24, { maxWidth: cardW - 12 });
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(120, 130, 145);
    doc.text(opt.subtitle || '', x + 6, y + 30, { maxWidth: cardW - 12 });

    // Eligibility highlight
    const elBg = isRec ? [236, 253, 245] : [243, 244, 246];
    doc.setFillColor(...elBg);
    doc.roundedRect(x + 6, y + 33, cardW - 12, 14, 2, 2, 'F');
    const elValue = opt.section105
      ? `${opt.section105.newEligibleCount} of ${opt.section125.totalEmployees} (${opt.section105.newEligibilityRate}%)`
      : `${opt.section125.eligibleCount} of ${opt.section125.totalEmployees} (${opt.section125.eligibilityRate}%)`;
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...(isRec ? [6, 95, 70] : [55, 65, 81]));
    doc.text(elValue + ' eligible', x + cardW / 2, y + 42, { align: 'center' });

    // Key metrics
    let ky = y + 53;
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(80, 90, 110);
    const metrics = [
      [`Your FICA savings`, fmtUSD(opt.totalEmployerFica)],
      [`Employee value`, fmtUSD(opt.totalEmployeeValue)],
      [`Cost to you`, opt.totalEmployeeCost > 0 ? `${fmtUSD(opt.totalEmployeeCost)}/yr` : '$0'],
      [`Net position`, `${opt.netEmployerPosition >= 0 ? '+' : ''}${fmtUSD(opt.netEmployerPosition)}`],
    ];
    metrics.forEach(([l, v]) => {
      doc.setTextColor(120, 130, 145);
      doc.text(l, x + 6, ky);
      doc.setTextColor(20, 30, 50);
      doc.setFont('helvetica', 'bold');
      doc.text(v, x + cardW - 6, ky, { align: 'right' });
      doc.setFont('helvetica', 'normal');
      ky += 5;
    });
  });

  y += cardH + 10;

  // Comparison table
  const a = options[0];
  const b = options[1];
  if (!a || !b) return;
  const rows = [
    ['Eligible employees',
      `${a.section125.eligibleCount} (${a.section125.eligibilityRate}%)`,
      b.section105 ? `${b.section105.newEligibleCount} (${b.section105.newEligibilityRate}%)` : `${b.section125.eligibleCount}`,
      b.section105?.bridgedEmployees > 0 ? `+${b.section105.bridgedEmployees}` : '—',
    ],
    ['Your FICA savings', fmtUSD(a.totalEmployerFica), fmtUSD(b.totalEmployerFica), `${b.totalEmployerFica - a.totalEmployerFica >= 0 ? '+' : ''}${fmtUSD(b.totalEmployerFica - a.totalEmployerFica)}`],
    ['Employee value', fmtUSD(a.totalEmployeeValue), fmtUSD(b.totalEmployeeValue), `+${fmtUSD(b.totalEmployeeValue - a.totalEmployeeValue)}`],
    ['Your cost', a.totalEmployeeCost > 0 ? fmtUSD(a.totalEmployeeCost) : '$0', b.totalEmployeeCost > 0 ? `-${fmtUSD(b.totalEmployeeCost)}` : '$0', 'investment'],
    ['Net after FICA + tax', `+${fmtUSD(a.netEmployerPosition)}`, `${b.netEmployerPosition >= 0 ? '+' : ''}${fmtUSD(b.netEmployerPosition)}`, ''],
    ['Healthcare access', cap(a.healthcareAccess || ''), cap(b.healthcareAccess || ''), ''],
    ['Compliance strength', cap(a.complianceStrength || ''), cap(b.complianceStrength || ''), ''],
  ];

  // Table header
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setFillColor(243, 244, 246);
  doc.rect(margin, y, PAGE_W - 2 * margin, 8, 'F');
  doc.setTextColor(70, 80, 100);
  const colW = (PAGE_W - 2 * margin) / 4;
  doc.text('Metric', margin + 3, y + 5.5);
  doc.text(a.label, margin + colW + 3, y + 5.5);
  doc.setTextColor(...BLUE);
  doc.text(`* ${b.label}`, margin + 2 * colW + 3, y + 5.5);
  doc.setTextColor(70, 80, 100);
  doc.text('Difference', margin + 3 * colW + 3, y + 5.5);
  y += 8;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  rows.forEach((r, idx) => {
    if (idx % 2 === 0) {
      doc.setFillColor(255, 255, 255);
    } else {
      doc.setFillColor(249, 250, 251);
    }
    doc.rect(margin, y, PAGE_W - 2 * margin, 7, 'F');
    doc.setTextColor(120, 130, 145);
    doc.text(r[0], margin + 3, y + 4.8);
    doc.setTextColor(20, 30, 50);
    doc.text(r[1], margin + colW + 3, y + 4.8);
    doc.setFont('helvetica', 'bold');
    doc.text(r[2], margin + 2 * colW + 3, y + 4.8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(80, 90, 110);
    doc.text(r[3] || '', margin + 3 * colW + 3, y + 4.8);
    y += 7;
  });

  // Status footer
  if (savedOptions.selectedOptionId) {
    y += 6;
    const sel = options.find((o) => o.id === savedOptions.selectedOptionId);
    if (sel) {
      doc.setFillColor(236, 253, 245);
      doc.roundedRect(margin, y, PAGE_W - 2 * margin, 12, 2, 2, 'F');
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(6, 95, 70);
      doc.text(`* Selected: ${sel.label} - ${sel.title}`, margin + 4, y + 7.5);
    }
  }
}

function fmtUSD(n) {
  if (n == null) return '$0';
  const abs = Math.abs(n);
  return `${n < 0 ? '-' : ''}$${abs.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
}
function cap(s) {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1).replace(/-/g, ' ');
}
